<template>
  <div
    id="events-filter--date-picker"
    @click.stop.prevent
  >
    <v-list dense>
      <v-list-item class="datepicker-list-item">
        <v-list-item-content>
          <v-select
            v-model="operator"
            dense
            filled
            color="primary"
            item-color="primary"
            :height="40"
            :items="['Before', 'After']"
            style="color: #535353;"
            @click.stop.prevent
          >
            <template v-slot:append>
              <font-awesome-icon
                icon="chevron-up"
                class="ml-5 operator-icon"
              />
            </template>
          </v-select>
        </v-list-item-content>
      </v-list-item>
      <v-list-item class="datepicker-list-item">
        <v-list-item-content>
          <v-menu
            ref="menu"
            v-model="menu"
            :close-on-content-click="false"
            :return-value.sync="date"
            transition="scale-transition"
            nudge-right="25"
            offset-x
            min-width="200px"
            @click.stop.prevent
          >
            <template v-slot:activator="{ on, attrs }">
              <v-text-field
                :value="formattedDate"
                append-icon="$faCalendarLight"
                placeholder="Select date"
                readonly
                filled
                dense
                single-line
                :height="40"
                color="primary"
                v-bind="attrs"
                v-on="on"
              />
            </template>
            <valkyrie-date-picker
              @submit-date="selectDate"
              @cancel="menu = false"
            />
          </v-menu>
        </v-list-item-content>
      </v-list-item>
      <v-list-item>
        <v-list-item-content>
          <v-btn
            color="primary"
            @click="updateFilter"
          >
            <span style="color: #fff;">Apply</span>
          </v-btn>
        </v-list-item-content>
      </v-list-item>
    </v-list>
  </div>
</template>
<script>
  import { DateTime } from 'luxon'
  import ValkyrieDatePicker from '@/components/base/ValkyrieDatePicker.vue'

  export default {
    name: 'DateFilter',
    components: { ValkyrieDatePicker },
    props: {
      filterKey: String,
    },
    data: () => ({
      date: null,
      menu: false,
      hour: '12',
      minute: '\0',
      period: 'AM',
      dateMenu: false,
      operator: 'Before',
    }),
    computed: {
      formattedDate () {
        return this.date ? DateTime.fromISO(this.date).toFormat('dd LLL yyyy') : ''
      },
    },
    methods: {
      selectDate ({ date, hour, minute, period }) {
        this.date = date
        this.hour = hour
        this.minute = minute
        this.period = period
        this.$refs.menu.save(date)
      },
      updateFilter () {
        const dateTimeString = `${this.date} ${this.hour}:${this.minute} ${this.period}`
        const dateValue = dateTimeString.replace(/-/g, '/')
        const value = new Date(dateValue).toISOString()
        const operator = this.operator === 'Before' ? '<=' : '>='
        // const readableValue = `${this.operator} ${this.formattedDate}`
        const payload = { key: this.filterKey, operator, value }
        this.$emit('apply-date-filter', payload)
      },
    },
  }
</script>
<style lang="scss">
#events-filter--date-picker {
  width: 204px;
  overflow-y: hidden;
  .theme--light.v-select .v-select__selection--comma {
    color: #535353;
    font-family: "Degular", sans-serif;
    font-size: 16px;
    letter-spacing: 0.62px;
    line-height: 20px;
  }
  .v-text-field--filled > .v-input__control > .v-input__slot, .v-text-field--full-width > .v-input__control > .v-input__slot, .v-text-field--outlined > .v-input__control > .v-input__slot {
    min-height: unset;
  }
  .operator-icon {
    height: 16px;
    width: 14px;
    color: #535353;
    margin-top: 4px;
  }
}
.datepicker-list-item {
  min-height: 30px;
  height: 69px !important;
  &:first-of-type {
    margin-top: 10px;
  }
}
</style>
